import { LclWeightBracketPrice } from "./lcl-weight-bracket-price.model";
import { LclWeightBracketPriceDict } from "./lcl-weight-bracket-price-dict.type";
import { LclWeightBracketName } from "./lcl-weight-bracket-name.type.const";
import { LclWeightBracketPriceDictMapper } from "./lcl-weight-bracket-price-dict.mapper";

export class LclWeightBracketPrices {
  private weightBracketPriceDict = <LclWeightBracketPriceDict>{};

  constructor(data: LclWeightBracketPrice[]) {
    this.setWeightBracketPriceDict(data);
  }

  public getPrices(): LclWeightBracketPriceDict {
    return this.weightBracketPriceDict;
  }

  public setPrices(param: LclWeightBracketPriceDict) {
    this.weightBracketPriceDict = param;
  }

  public getPrice(param: LclWeightBracketName): number {
    return this.getPrices()[param] ? this.getPrices()[param].getValue() : null;
  }

  public setPrice(param: LclWeightBracketName, val: number) {
    try {
      this.getPrices()[param] = new LclWeightBracketPrice(param, val);
    } catch (e) {
      console.error(`can't set ${param} container with ${val} (${e})`);
    }
  }

  public getWeightBracketPriceNames(): LclWeightBracketName[] {
    return <LclWeightBracketName[]>Object.keys(this.weightBracketPriceDict);
  }

  public getRequestParams() {
    return LclWeightBracketPriceDictMapper.toArray(this.weightBracketPriceDict);
  }

  public hasAtLeastOnePrice(equipment: string[] = []) {
    return equipment
      .map((weightBracketName) =>
        this.weightBracketPriceDict[weightBracketName]
          ? this.weightBracketPriceDict[weightBracketName]
          : null,
      )
      .some((val) => val !== null);
  }

  private setWeightBracketPriceDict(
    data: LclWeightBracketPrices | LclWeightBracketPrice[],
  ) {
    if (data instanceof LclWeightBracketPrices) {
      this.weightBracketPriceDict = { ...data.getPrices() };
    }

    if (Array.isArray(data)) {
      this.weightBracketPriceDict =
        LclWeightBracketPriceDictMapper.toDict(data);
    }
  }
}
